const Address = ({
  bairro = String(),
  cep = String(),
  complemento = String(),
  ddd = String(),
  gia = String(),
  ibge = String(),
  localidade = String(),
  logradouro = String(),
  siafi = String(),
  uf = String(),
  erro
}) => ({
  neighborhood: bairro,
  cep,
  complement: complemento,
  ddd,
  gia,
  ibge,
  city: localidade,
  street: logradouro,
  siafi,
  uf: uf?.toLowerCase(),
  erro
})

export default {
  Address,
}
